import script from "./ViewSuspense.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSuspense.vue?vue&type=script&setup=true&lang=js"

import "./ViewSuspense.vue?vue&type=style&index=0&id=4627a10e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4627a10e"]])

export default __exports__